module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ProductEvaluateDetailView.js"));
	}, "ProductEvaluateDetail");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProductEvaluateDetail!./src/pages/Shop/Product/ProductDetail/ProductEvaluateDetail/ProductEvaluateDetailView.js
// module id = 877
// module chunks = 431